// src/pages/post/CategoryPosts.jsx
import React, { useState, useEffect } from 'react';
import PostItem from '../../components/post/PostItem';
import Loader from '../../components/common/Loader';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const CategoryPosts = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { category } = useParams();

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/categories/${category}`);
        if (Array.isArray(response?.data)) {
          setPosts(response.data);
        } else if (response?.data?.posts && Array.isArray(response.data.posts)) {
          setPosts(response.data.posts);
        } else {
          setPosts([]);
          setError("Received invalid data format from server");
        }
      } catch (err) {
        console.error("Error fetching category posts:", err);
        setError("Failed to load posts. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchPosts();
  }, [category]);

  if (isLoading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center py-12">
        <Loader />
      </div>
    );
  }

  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <header className="mb-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900">
            <span className="text-gray-600">Category:</span> {category}
          </h1>
          <div className="mt-2 h-1 w-24 bg-primary mx-auto rounded"></div>
        </header>
        
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mb-6" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        {!isLoading && !error && posts.length === 0 && (
          <div className="text-center py-12 bg-white rounded-lg shadow-sm">
            <h2 className="text-2xl font-bold text-gray-700">No Posts Found in This Category</h2>
            <p className="text-gray-500 mt-2">Be the first to create a post in the {category} category.</p>
          </div>
        )}
        
        {posts.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {posts.map(({ _id: id, thumbnail, category, title, description, creator, createdAt }) => (
              <PostItem
                key={id}
                postID={id}
                thumbnail={thumbnail}
                category={category}
                title={title}
                description={description}
                authorID={creator}
                createdAt={createdAt}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CategoryPosts;